<ng-container *ngIf="value | isNotNullorUndefined">{{ value! | translocoDecimal: { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}&nbsp;€</ng-container>
